module.exports = __webpack_public_path__ + "static/media/ArrowDownWhite.33e3625d.svg";